import React, { Component } from 'react';
import GetCategoryDetails from '../../../services/GetCategoryDetails';
import AutoSelect from "../../autoselect";

const Arrays = (data, fieldName, fieldValue) => {
  let arrayItem = [];
  if (data && Array.isArray(data)) {
    data.forEach((item) => {
      arrayItem.push({ label: item[fieldName], value: item[fieldValue] });
    });
  }
  return arrayItem;
};

export default class MainCategorylist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getList: [],
      selectCategory: null,
    };
  }

  async componentDidMount() {
    this.getCategories();
  }

  async getCategories() {
    try {
      let list = await GetCategoryDetails.getCategoryList();
      if (list && list.data) {
        this.setState({ getList: list.data });
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }

  handleSelectChange = (name, selected) => {
    if (name === "category_id" && selected) {
      this.setState({
        selectCategory: selected,
      });

      // ✅ Send {id, name} back to parent (Edit.js)
      if (this.props.handleCategorySelect) {
        this.props.handleCategorySelect({
          id: selected.value,
          name: selected.label,
        });
      }
    }
  };

  render() {
    const { getList, selectCategory } = this.state;

    return (
      <div>
        <AutoSelect
          className="basic-single"
          value={selectCategory}
          onChange={this.handleSelectChange}
          isSearchable={true}
          name="category_id"
          options={Arrays(getList, "name", "id")}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/category/main-category/index.js